export default "{\n    \"overview\": {\n        \"selfServeSignup\": \"CRM only?\"\n    }\n}\n"